module.exports = __webpack_public_path__ + "static/ai-4-sq-efff22db20b691acebfdbcd185ae58f0.png";